import type React from "react";

export function Divider(): React.ReactNode {
  return <hr className="w-full border-t-0 border-b border-border-default" />;
}
